import { getBonusMinDeposit } from '@/entities/bonus/model/get-bonus-min-deposit';

export const isDepositBonus = (bonus: any) => getBonusMinDeposit(bonus) > 0;
